// AuthErrorScreen — bad_hash / expired / server (and friends).
// Faithful port of the design bundle (screens-auth.jsx · AuthError). The auth
// state's errorReason maps onto the design's three variants; the CTA re-auths.
import { useAuth } from '../auth/AuthProvider'
import { AuthTopBar } from '../components/AuthTopBar'
import { getWebApp } from '../telegram/tg'
import { Button, Icon, t } from '../design'

type Variant = 'bad_hash' | 'expired' | 'server'

const VARIANTS: Record<Variant, { icon: any; tone: 'danger' | 'warning' | 'neutral'; cta: string; ctaIcon: any }> = {
  bad_hash: { icon: Icon.AlertTri, tone: 'danger', cta: 'auth.err.badhash.cta', ctaIcon: Icon.Refresh },
  expired: { icon: Icon.Clock, tone: 'warning', cta: 'auth.err.expired.cta', ctaIcon: Icon.Telegram },
  server: { icon: Icon.CloudOff, tone: 'neutral', cta: 'auth.err.server.cta', ctaIcon: Icon.Refresh },
}

// Auth state reasons → the three designed error variants.
function toVariant(reason: string | null): Variant {
  if (reason === 'bad_hash') return 'bad_hash'
  if (reason === 'expired' || reason === 'invalid') return 'expired'
  return 'server'
}

export function AuthErrorScreen() {
  const { errorReason, retry } = useAuth()
  const variant = toVariant(errorReason)
  const cfg = VARIANTS[variant]
  const IconCmp = cfg.icon
  const CtaIcon = cfg.ctaIcon
  const toneBg = cfg.tone === 'danger' ? 'var(--danger-bg)' : cfg.tone === 'warning' ? 'var(--warning-bg)' : 'var(--surface-2)'
  const toneFg = cfg.tone === 'danger' ? 'var(--danger)' : cfg.tone === 'warning' ? 'var(--warning)' : 'var(--text-2)'
  const close = () => {
    try { getWebApp()?.close() } catch { /* noop outside Telegram */ }
  }

  return (
    <>
      <AuthTopBar onBack={close} />
      <div className="scroll-y" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 18, padding: '20px 16px' }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{ width: 72, height: 72, borderRadius: 20, background: toneBg, color: toneFg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}>
            <IconCmp size={32} sw={2} />
          </span>
          <div className="t-h1" style={{ marginBottom: 6 }}>{t('auth.err.' + variant + '.title')}</div>
          <div className="t-caption" style={{ maxWidth: 290, margin: '0 auto', lineHeight: 1.5 }}>{t('auth.err.' + variant + '.body')}</div>
        </div>

        <div className="card" style={{ padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10, background: 'var(--surface-2)' }}>
          <Icon.Alert size={14} sw={2} style={{ color: 'var(--text-3)', flexShrink: 0 }} />
          <span className="t-mono t-caption" style={{ color: 'var(--text-3)' }}>reason: {errorReason || 'server'}</span>
        </div>

        <Button variant="primary" full icon={<CtaIcon size={16} sw={2} />} onClick={retry}>{t(cfg.cta)}</Button>
      </div>
    </>
  )
}
